import Vuex from 'vuex';

import state from './state';
import actions from './actions';
import mutations from './mutations';
import getters from './getters';

export const store = new Vuex.Store({
    state,

    getters,

    mutations, 

    actions,
});


// WEBPACK FOOTER //
// ./src/store/index.js